import React, { useContext, useEffect } from "react";
import Webcam from "react-webcam";
import styled from "styled-components";
import StateContext from "../context/StateContext";

const videoConstraints = {
  width: 1280,
  height: 720,
  facingMode: "user",
};

const StyledWebcam = styled(Webcam)`
  visible: false;
`;

function WebcamCapture({ ...props }) {
  const [state, dispatch] = useContext(StateContext);
  const webcamRef = React.useRef(null);
  const capture = React.useCallback(() => {
    console.log("Capturing image");
    if (state.captureNewImage) {
      dispatch({
        type: "setUserImage",
        payload: webcamRef.current.getScreenshot({ width: 1920, height: 1080 }),
      });
    }
  }, [webcamRef, state, dispatch]);

  useEffect(() => {
    const timer = setTimeout(capture, 3000);

    return () => clearTimeout(timer);
  }, [capture]);

  return (
    <>
      <StyledWebcam
        audio={false}
        height={0}
        width={0}
        ref={webcamRef}
        minScreenshotHeight={1080}
        minScreenshotWidth={1920}
        videoConstraints={videoConstraints}
        screenshotFormat="image/png"
      />
    </>
  );
}

export default WebcamCapture;
